<template>
  <div
    class="sv-catalog container"
    :class="`sv-catalog--mobile-${config.mobile_size} sv-catalog--desktop-${config.desktop_size}`"
    v-show="displayedProducts.length"
    :style="{ opacity: stylesLoaded ? 1 : 0 }"
    ref="catalog"
  >
    <h3
      class="catalog-title"
      :class="`catalog-title--mobile-${config.mobile_size} catalog-title--desktop-${config.desktop_size}`"
      v-if="config.is_show_title && config.name"
    >{{ config.name }}</h3>
    <div class="row" :class="centerItems ? 'justify-content-center' : ''">
      <div
        class="display-product-item"
        :class="`display-product-item--mobile-${config.mobile_size} display-product-item--desktop-${config.desktop_size}`"
        v-for="(product, index) in displayedProducts"
        :key="index"
      >
        <div
          class="product-details"
          @click="productClick(`catalog_widget?c=${config.c}&source=widget_${config.id}&product_id=${primaryVariant(product).site_product_id}&icv=${config.icv.id}${couponCodeUrl}&action=details`)"
        >
          <div
            class="display-product-item__image"
            :style="{backgroundImage: `url('https://snapsupplements.com/images/layouts/${product.layout}/product/thumbnails/${primaryVariant(product).product_image}')`}"
          ></div>
          <h5
            class="display-product-item__name"
            v-if="config.is_show_product_name"
          >{{ product.name }}</h5>
          <div class="display-product-item__tags" v-if="config.is_show_badges">
            <div v-for="tag in product.site_tags" :key="tag.id">
              <span
                :style="`color: ${product.product_colors.badges_color}; border-color: ${product.product_colors.badges_color};`"
              >{{tag.tag}}</span>
            </div>
          </div>
          <p
            class="display-product-item__desc"
            v-if="config.is_show_description"
          >{{ product.description }}</p>
          <p class="display-product-item__price" v-if="config.is_show_price">
            ${{ (+primaryVariantPrice(primaryVariant(product))).toFixed(2) }}
            <s
              v-if="primaryVariantPrice(primaryVariant(product)) < primaryVariant(product).price * primaryVariant(product).default_quantity"
            >${{ (+primaryVariant(product).price * primaryVariant(product).default_quantity).toFixed(2) }}</s>
          </p>
          <div class="display-product-item__stars" v-if="config.is_show_reviews">
            <review-stars :stars="product.review_stats" />
          </div>
        </div>
        <div
          class="display-product-item__btn-wrapper"
          :class="`display-product-item__btn-wrapper--${config.cta_radius}`"
        >
          <button
            type="button"
            class="sv-btn sv-btn--secondary details-btn"
            @click="productClick(`catalog_widget?c=${config.c}&source=widget_${config.id}&product_id=${primaryVariant(product).site_product_id}&icv=${config.icv}${couponCodeUrl}&action=details`)"
            :style="{borderColor: `${config.button_color}`}"
          >Details</button>
          <button
            type="button"
            class="sv-btn sv-btn--primary purchase-btn"
            @click="productClick(`catalog_widget?c=${config.c}&source=widget_${config.id}&product_id=${primaryVariant(product).site_product_id}&icv=${config.icv}${couponCodeUrl}&action=buy`)"
            :style="{backgroundColor: `${config.button_color}`, borderColor: `${config.button_color}`}"
          >
            <span class="purchase-btn--sm">Buy</span>
            <span class="purchase-btn--lg">Buy Now</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewStars from "./ReviewStars";
import axios from "axios";

export default {
  components: {
    ReviewStars
  },
  props: {
    productClick: {
      type: Function,
      required: true
    },
    setHeight: {
      type: Function,
      required: true
    },
    inIframe: {
      type: Boolean,
      required: true
    },
    catalogIframe: {
      type: HTMLIFrameElement
    },
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      stylesLoaded: process.env.NODE_ENV === "development" ? true : false,
      siteProducts: null,
      showModal: false,
      isMobile: "",
      isScreenXSmall: "",
      isScreenSmall: "",
      isScreenMedium: "",
      isScreenLarge: "",
      screenWidth: "",
      config: {
        button_color: "",
        c: "",
        cta_radius: 0,
        desktop_rows: 0,
        desktop_size: "medium",
        font: "",
        icv: "",
        id: "",
        is_show_badges: true,
        is_show_description: false,
        is_show_price: true,
        is_show_product_name: true,
        is_show_reviews: true,
        is_show_title: true,
        mobile_rows: 0,
        mobile_size: "medium",
        name: process.env.NODE_ENV === "development" ? "Title of Widget" : "",
        products:
          process.env.NODE_ENV === "development"
            ? [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
                31,
                32,
                33,
                34,
                35,
                36
              ]
            : [],
        promo_code: null
      }
    };
  },
  watch: {
    displayedProducts() {
      this.updateHeight();
    },
    inIframe(newVal) {
      this.$nextTick(() => {
        if (newVal) {
          const catalog = this.catalogIframe;

          const mqXSmall = catalog.contentWindow.matchMedia(
            "(max-width: 575px)"
          );

          const mqSmall = catalog.contentWindow.matchMedia(
            "(min-width:576px) and (max-width: 767px)"
          );
          const mqMedium = catalog.contentWindow.matchMedia(
            "(min-width:768px) and (max-width: 1023px)"
          );
          const mqLarge = catalog.contentWindow.matchMedia(
            "(min-width: 1024px)"
          );

          mqXSmall.addListener(this.screenTestXSmall);
          mqSmall.addListener(this.screenTestSmall);
          mqMedium.addListener(this.screenTestMedium);
          mqLarge.addListener(this.screenTestLarge);

          this.screenTestXSmall(mqXSmall);
          this.screenTestSmall(mqSmall);
          this.screenTestMedium(mqMedium);
          this.screenTestLarge(mqLarge);

          catalog.contentWindow.addEventListener("resize", () => {
            this.updateHeight();
          });
          // set iframe sizes xs 320, sm 435, md, 580, lg: 870
        }
      });
    }
  },
  created() {
    document.body.addEventListener("svConfigsLoaded", e => {
      const allConfigs = JSON.parse(e.detail.configs);
      this.config = allConfigs[this.token];
    });
    document.body.addEventListener(
      `svStylesLoaded${this.token}`,
      this.setStylesLoaded.bind(null)
    );
  },
  mounted() {
    this.$nextTick(() => {
      const siteProductsUrl =
        process.env.NODE_ENV === "development"
          ? location.href
          : "https://catalog.snapsupplements.com/";

      axios.get(`${siteProductsUrl}site_products.json`).then(res => {
        if (res.data) {
          this.siteProducts = res.data;
        } else {
          console.log("Failed to load Snap site products");
        }
      });

      if (window.svConfigs) {
        const allConfigs = JSON.parse(window.svConfigs);
        this.config = allConfigs[this.token];
      }

      if (process.env.NODE_ENV === "development") {
        const configUrl =
          process.env.NODE_ENV === "development"
            ? "http://snap.test/"
            : "https://snapsupplements.com/";

        const url = window.location.hostname + window.location.pathname;

        // prod: 4wiXDKAwAgGYAqRRChad, mWjQHjzBIaC9oXVsfcit
        // dev: VGTx3039waI66bVKFOhR, G2DttNh6V8pKGqUGzeRc, ZlmM5aXKrb4kiQfOGHqp
        // &tokens[]=VGTx3039waI66bVKFOhR&tokens[]=VGTx3039waI66bVKFOhR&tokens[]=VGTx3039waI66bVKFOhR
        // &tokens[]=G2DttNh6V8pKGqUGzeRc&tokens[]=ZlmM5aXKrb4kiQfOGHqp

        axios
          .get(`${configUrl}api/get_widgets?url=${url}&tokens[]=${this.token}`)
          .then(res => {
            this.config = res.data[this.token];
          });
      }
    });
  },
  computed: {
    coupon() {
      return this.config.promo_code instanceof Array ||
        this.config.promo_code === null
        ? {}
        : this.config.promo_code;
    },
    couponCodeUrl() {
      return this.coupon.code ? `&p=${this.coupon.code}` : "";
    },
    displayedProducts() {
      let filteredArray = [];

      if (this.siteProducts && this.config.products.length) {
        const productIds = this.config.products;
        productIds.forEach(id => {
          if (this.siteProducts[id] && this.siteProducts[id].is_displayed) {
            filteredArray.push(this.siteProducts[id]);
          }
        });

        let numberToDisplay = this.siteProducts.length;
        if (this.isScreenXSmall && this.config.mobile_rows > 0) {
          if (this.config.mobile_size === "small") {
            numberToDisplay = 3 * this.config.mobile_rows;
          } else if (this.config.mobile_size === "medium") {
            numberToDisplay = 2 * this.config.mobile_rows;
          } else {
            numberToDisplay = this.config.mobile_rows;
          }
        } else if (this.isScreenSmall && this.config.desktop_rows > 0) {
          if (this.config.desktop_size === "small") {
            numberToDisplay = 3 * this.config.desktop_rows;
          } else if (this.config.desktop_size === "medium") {
            numberToDisplay = 2 * this.config.desktop_rows;
          } else {
            numberToDisplay = this.config.desktop_rows;
          }
        } else if (this.isScreenMedium && this.config.desktop_rows > 0) {
          if (this.config.desktop_size === "small") {
            numberToDisplay = 4 * this.config.desktop_rows;
          } else if (this.config.desktop_size === "medium") {
            numberToDisplay = 3 * this.config.desktop_rows;
          } else {
            numberToDisplay = 2 * this.config.desktop_rows;
          }
        } else if (this.isScreenLarge && this.config.desktop_rows > 0) {
          if (this.config.desktop_size === "small") {
            numberToDisplay = 6 * this.config.desktop_rows;
          } else if (this.config.desktop_size === "medium") {
            numberToDisplay = 4 * this.config.desktop_rows;
          } else {
            numberToDisplay = 3 * this.config.desktop_rows;
          }
        }
        filteredArray = filteredArray.slice(0, numberToDisplay);
      }
      return filteredArray;
    },
    centerItems() {
      if (this.isScreenXSmall) {
        if (
          this.config.mobile_size === "small" &&
          this.displayedProducts.length < 3
        ) {
          return true;
        } else if (
          this.config.mobile_size === "medium" &&
          this.displayedProducts.length < 2
        ) {
          return true;
        }
      } else if (this.isScreenSmall) {
        if (
          this.config.desktop_size === "small" &&
          this.displayedProducts.length < 3
        ) {
          return true;
        } else if (
          this.config.desktop_size === "medium" &&
          this.displayedProducts.length < 2
        ) {
          return true;
        }
      } else if (this.isScreenMedium) {
        if (
          this.config.desktop_size === "small" &&
          this.displayedProducts.length < 4
        ) {
          return true;
        } else if (
          this.config.desktop_size === "medium" &&
          this.displayedProducts.length < 3
        ) {
          return true;
        } else if (
          this.config.desktop_size === "large" &&
          this.displayedProducts.length < 2
        ) {
          return true;
        }
      } else if (this.isScreenLarge) {
        if (
          this.config.desktop_size === "small" &&
          this.displayedProducts.length < 6
        ) {
          return true;
        } else if (
          this.config.desktop_size === "medium" &&
          this.displayedProducts.length < 4
        ) {
          return true;
        } else if (
          this.config.desktop_size === "large" &&
          this.displayedProducts.length < 3
        ) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    setStylesLoaded() {
      this.$nextTick(() => {
        this.stylesLoaded = true;
        this.$nextTick(() => this.updateHeight());
      });
    },
    updateHeight() {
      if (this.$refs.catalog) {
        this.updateHeightTimeout;
        clearTimeout(this.updateHeightTimeout);
        this.updateHeightTimeout = setTimeout(() => {
          const height = this.outerHeight(this.$refs.catalog);
          this.setHeight(height);
        }, 100);
      }
    },
    outerHeight(element) {
      let height = element.offsetHeight;
      const style = getComputedStyle(element);
      height +=
        parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
      return height;
    },
    primaryVariant: function(product) {
      const primaryVariantID = product.primary_variant_id;
      return product.vars[primaryVariantID];
    },
    primaryVariantPrice: function(variant) {
      return (
        this.getPricePerItem(
          variant,
          variant.default_quantity,
          "one_time",
          this.coupon
        ) * variant.default_quantity
      );
    },
    getPricePerItem(product, qty, period, coupon = {}) {
      const price = +product.price;
      const min_price = +product.min_price;
      const discount = +product.discount;
      const progressive_discount = +product.progressive_discount;

      const subscription_discount =
        (period || "every_month").indexOf("every") > -1
          ? +product.subscription_discount
          : 0;

      const quantity = qty || +product.quantity || 1;

      let productCost = Math.max(
        min_price,
        price -
          discount -
          subscription_discount -
          progressive_discount * (quantity - 1)
      );

      if (coupon.id && coupon.type === "%") {
        const included = (coupon.products_included || []).map(id => +id);
        const excluded = (coupon.products_excluded || []).map(id => +id);

        if (
          (included.length === 0 && excluded.length === 0) ||
          (included.indexOf(product.id) > -1 &&
            excluded.indexOf(product.id) === -1)
        ) {
          productCost *= 1 - +coupon.discount;
        }
      }

      return Math.round(productCost * 100) / 100;
    },
    // set iframe sizes xs 320, sm 435, md, 580, lg: 870
    screenTest: function(e) {
      this.isMobile = !e.matches;
    },
    screenTestXSmall: function(e) {
      this.isScreenXSmall = e.matches;
      if (e.matches) {
        this.isScreenSmall = false;
        this.isScreenMedium = false;
        this.isScreenLarge = false;
      }
    },
    screenTestSmall: function(e) {
      this.isScreenSmall = e.matches;
      if (e.matches) {
        this.isScreenXSmall = false;
        this.isScreenMedium = false;
        this.isScreenLarge = false;
      }
    },
    screenTestMedium: function(e) {
      this.isScreenMedium = e.matches;
      if (e.matches) {
        this.isScreenXSmall = false;
        this.isScreenSmall = false;
        this.isScreenLarge = false;
      }
    },
    screenTestLarge: function(e) {
      this.isScreenLarge = e.matches;
      if (e.matches) {
        this.isScreenXSmall = false;
        this.isScreenSmall = false;
        this.isScreenMedium = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/_variables.scss";
@import "../assets/sass/_mixins.scss";

$mobile-width: 320;
$mobile-small: $mobile-width / 3;
$mobile-medium: $mobile-width / 2;
$mobile-large: $mobile-width;

$desktop-width: 870;
$desktop-small: $desktop-width / 6;
$desktop-medium: $desktop-width / 4;
$desktop-large: $desktop-width / 3;

.sv-catalog {
  @media (max-width: $screen-xs-max) {
    max-width: 320px;
  }
  @media (min-width: $screen-lg-min) {
    max-width: 870px;
  }
}

.sv-catalog--desktop-small {
  @media (min-width: $screen-sm-min) {
    max-width: $desktop-small * 3px;
  }
  @media (min-width: $screen-md-min) {
    max-width: $desktop-small * 4px;
  }
  @media (min-width: $screen-lg-min) {
    max-width: $desktop-small * 6px;
  }
}

.sv-catalog--desktop-medium {
  @media (min-width: $screen-sm-min) {
    max-width: $desktop-medium * 2px;
  }
  @media (min-width: $screen-md-min) {
    max-width: $desktop-medium * 3px;
  }
  @media (min-width: $screen-lg-min) {
    max-width: $desktop-medium * 4px;
  }
}

.sv-catalog--desktop-large {
  @media (min-width: $screen-sm-min) {
    max-width: $desktop-large * 1px;
  }
  @media (min-width: $screen-md-min) {
    max-width: $desktop-large * 2px;
  }
  @media (min-width: $screen-lg-min) {
    max-width: $desktop-large * 3px;
  }
}

.catalog-title {
  text-align: center;
}

.catalog-title--mobile-large {
  @media (max-width: $screen-xs-max) {
    line-height: 46px;
    font-size: 38px;
  }
}

.display-product-item {
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  @media (min-width: $screen-sm-min) {
    margin-top: 50px;
  }
  a {
    text-decoration: none;
  }
  div,
  p,
  h5 {
    transition: opacity 200ms;
  }
  .product-details:hover > div,
  .product-details:hover p,
  .product-details:hover h5 {
    opacity: 0.7;
    cursor: pointer;
  }
  .display-product-item__stars {
    margin-top: 10px;
  }
}

.display-product-item__image {
  padding-bottom: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: block;
  position: relative;
  overflow: hidden;
}

.display-product-item__name {
  margin-top: 10px;
  text-decoration: none;
}

.display-product-item__tags {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -5px 0;
  height: 30px;
  overflow: hidden;
  div {
    padding: 5px;
    margin-top: 10px;
  }
  span {
    padding: 3px 4px;
    border-radius: 2px;
    border: 1px solid $sv-gray3;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 10px;
    line-height: 1;
    letter-spacing: 0.8px;
    color: $sv-gray3;
    line-height: 1;
    white-space: nowrap;
  }
}

.display-product-item__desc {
  display: none;
  margin-top: 10px;
  @media (min-width: $screen-sm-min) {
    display: block;
  }
}

.display-product-item__price {
  margin-top: 10px;
  line-height: 20px;
  font-size: 14px;
  text-decoration: none;
  @include font-bold;
  @media (min-width: $screen-sm-min) {
    font-size: 16px;
  }
  s {
    @include font-regular;
    color: $sv-gray3;
  }
}

.display-product-item__btn-wrapper {
  margin: auto auto 0;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  max-width: 160px + 75;
  width: 100%;
  .sv-btn {
    margin-top: 20px;
  }
  .details-btn {
    display: none;
    @media (min-width: $screen-sm-min) {
      display: block;
      padding: 0 10px;
      min-width: 0;
    }
  }
  .purchase-btn {
    color: white;
    transition: opacity 200ms;
    @media (max-width: $screen-xs-max) {
      width: 160px;
      max-width: 100%;
    }
    @media (min-width: $screen-sm-min) {
      flex-grow: 1;
    }
  }
  .purchase-btn:hover {
    opacity: 0.8;
  }
}

.display-product-item__btn-wrapper--0 {
  .sv-btn {
    border-radius: 0;
  }
}
.display-product-item__btn-wrapper--4 {
  .sv-btn {
    border-radius: 4px;
  }
}
.display-product-item__btn-wrapper--25 {
  .sv-btn {
    border-radius: 25px;
  }
}

.purchase-btn--sm {
  @media (min-width: $screen-sm-min) {
    display: none;
  }
}
.purchase-btn--lg {
  display: none;
  @media (min-width: $screen-sm-min) {
    display: block;
  }
}

.display-product-item--mobile-small {
  @media (max-width: $screen-xs-max) {
    padding-left: 7.5px;
    padding-right: 7.5px;
    flex: 0 0 $mobile-small * 1px;
    max-width: $mobile-small * 1px;
    .display-product-item__name {
      line-height: 20px;
      font-size: 16px;
      margin-top: 5px;
    }
    .display-product-item__tags {
      span {
        font-size: 8px;
        letter-spacing: 0.67px;
      }
    }
    .display-product-item__price {
      font-size: 12px;
    }
    .display-product-item__btn-wrapper {
      .sv-btn {
        width: 100%;
        min-width: 0;
        height: 40px;
        line-height: 36px;
        margin-top: 10px;
      }
    }
  }
}

.display-product-item--mobile-medium {
  @media (max-width: $screen-xs-max) {
    flex: 0 0 $mobile-medium * 1px;
    max-width: $mobile-medium * 1px;

    .display-product-item__name {
      @include font-condensed-medium;
      font-size: 26px;
    }
    .display-product-item__tags {
      span {
        font-size: 8px;
        letter-spacing: 0.67px;
      }
    }

    .display-product-item__price {
      font-size: 15px;
    }

    .display-product-item__btn-wrapper {
      .sv-btn {
        width: 100%;
        min-width: 0;
        height: 40px;
        line-height: 36px;
        margin-top: 10px;
      }
    }
    .purchase-btn--lg {
      display: block;
    }
    .purchase-btn--sm {
      display: none;
    }
  }
}

.display-product-item--mobile-large {
  @media (max-width: $screen-xs-max) {
    flex: 0 0 $mobile-large * 1px;
    max-width: $mobile-large * 1px;

    .display-product-item__name {
      @include font-condensed-medium;
      line-height: 44px;
      font-size: 36px;
    }
    .display-product-item__price {
      font-size: 20px;
    }
    .display-product-item__desc {
      display: block;
    }
    .purchase-btn--lg {
      display: block;
    }
    .purchase-btn--sm {
      display: none;
    }
    .display-product-item__btn-wrapper {
      margin: auto auto 0;
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      max-width: 280px;
      width: 100%;
      .sv-btn {
        margin-top: 15px;
      }
      .details-btn {
        display: block;
        padding: 0 10px;
        min-width: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .purchase-btn {
        flex-grow: 1;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
}

.display-product-item--desktop-small {
  @media (min-width: $screen-sm-min) {
    flex: 0 0 $desktop-small * 1px;
    max-width: $desktop-small * 1px;
    .display-product-item__name {
      margin-top: 10px;
      line-height: 20px;
      font-size: 16px;
    }
    .display-product-item__desc {
      display: none;
    }
    .display-product-item__btn-wrapper {
      .details-btn {
        display: none;
      }
      .sv-btn {
        height: 40px;
        line-height: 36px;
      }
    }
  }
}

.display-product-item--desktop-medium {
  @media (min-width: $screen-sm-min) {
    flex: 0 0 $desktop-medium * 1px;
    max-width: $desktop-medium * 1px;
    .display-product-item__name {
      font-size: 20px;
    }
    .purchase-btn--lg {
      display: block;
    }
    .purchase-btn--sm {
      display: none;
    }
    .display-product-item__btn-wrapper {
      .purchase-btn {
        flex-grow: 1;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
      .details-btn {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}

.display-product-item--desktop-large {
  @media (min-width: $screen-sm-min) {
    flex: 0 0 $desktop-large * 1px;
    max-width: $desktop-large * 1px;
  }
  .display-product-item__btn-wrapper {
    .purchase-btn {
      flex-grow: 1;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .details-btn {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
</style>